import axiosVirdioT from '../utils/axios';
var axiosVirdio = new axiosVirdioT(); 

const bookmarkClass = function(classId, classType, classStatus) {
	return new Promise(function (resolve, reject) {
		var postData = {classId: classId, classType: classType, classStatus: classStatus};
		
		let token = JSON.parse(localStorage.getItem('userData')).token;
		axiosVirdio.auth(token);
		
		axiosVirdio.post(process.env.REACT_APP_API_URL +'/api/v1/session/bookmarkClass', postData).then(res => {
			resolve('success');
		}).catch(err =>{ reject(err); });
	});
}


export { bookmarkClass } 